export default __webpack_public_path__ + "static/link4-d4d7ee532cd392593902651b4c3b1ee3.svg";